<template>
  <div>
    <Card>
      <ui-copy-textarea
        label="Tex label"
        value="Long long example text here. Long long example text here. Long long example text here. Long long example text here. Long long example text here. Long long example text here. Long long example text here. Long long example text here."
      />
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
